module.exports = __webpack_public_path__ + "static/media/arrow2.c199cab4.svg";